import React from "react";
import { motion } from "framer-motion";

const ProjectsCard = ({ image, title, category }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      viewport={{ once: true }}
      className="bg-gray-800 rounded-xl overflow-hidden border border-gray-700 hover:border-blue-500 transition-colors duration-300"
    >
      <div className="relative overflow-hidden group">
        <motion.img
          initial={{ scale: 1 }}
          whileHover={{ scale: 1.05 }}
          className="w-full h-48 object-cover transition-transform duration-500"
          src={image}
          alt={title}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-gray-900/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4">
          <div>
            <h3 className="text-xl font-semibold text-white">{title}</h3>
            <p className="text-blue-400">{category}</p>
          </div>
        </div>
      </div>

      <div className="p-4">
        <h3 className="text-lg font-medium text-gray-200">{title}</h3>
        <p className="text-gray-400 mt-1">{category}</p>
      </div>
    </motion.div>
  );
};

export default ProjectsCard;